<div class="media">
    {{media | number : '1.1-1'}}
</div>